import { connect } from 'react-redux';
import * as R from 'ramda';
import { loadingManagementApi } from 'feature/loading-management/loadingManagementApi';
import {
  batchActivate,
  getInactiveSelfAuthorizationsSelected,
  setSubmittingBatch,
} from '../../store/createNewSelfAuthorizationSlice';
import {
  fetchSelfAuthorizations,
  fetchUniqueSelectors,
  getCurrentSelection,
  setSelfAuthorizationsPending,
} from '../../store/selfAuthorizationsSlice';

import ConfirmAndSubmitStep from './ConfirmAndSubmit';
import { ACTIVE_TAB_SELF_AUTH_MAP } from '../../../utils/const';

const mapState = state => {
  const { affiliate, locationId, productId, selfAuthType } =
    state.loadingManagement.createNewSelfAuth.params;
  const testId = locationId || productId;
  const { viewByList } = state.loadingManagement.createNewSelfAuth;
  const { nameShort } = viewByList.find(({ id }) => id === testId) || {};
  const listType = R.invertObj(ACTIVE_TAB_SELF_AUTH_MAP)[selfAuthType];

  return {
    affiliate: {
      companyCustomerIdName: affiliate.customerIdName,
      dataCompanyId: affiliate.dataCompanyId,
    },
    currentSelection: getCurrentSelection(state),
    identifier: nameShort,
    inactiveSelfAuthorizationsSelected: getInactiveSelfAuthorizationsSelected(state),
    listType,
    locationId,
    productId,
    selfAuthorizationsPending: state.loadingManagement.selfAuthorizations.selfAuthorizationsPending,
    submittingBatch: state.loadingManagement.createNewSelfAuth.submittingBatch,
  };
};

const mapDispatchToProps = {
  batchActivate,
  fetchSelfAuthorizations,
  fetchUniqueSelectors,
  refreshSelfAuthorizationsListView: () =>
    loadingManagementApi.util.invalidateTags(['SelfAuthorizationList']),
  setSelfAuthorizationsPending,
  setSubmittingBatch,
};

export default connect(mapState, mapDispatchToProps)(ConfirmAndSubmitStep);
